export const environment = {
  API_URL: 'https://pareplicaapi.partanalytics.com/api/v1',
  API_URL_V2: 'https://pareplicaapi.partanalytics.com/api/v2',

  // API_URL: 'https://api-next.partanalytics.com/api/v1',
  // API_URL: 'http://ec2-3-227-23-49.compute-1.amazonaws.com:3600/api/v1',
  production: true,
  authSecretKey: "fAhichanoch1d!tlfotr",
  storageEncryptDecryptKey: "43ea6df2-314a-42ee-ab82-9f8c20e5c736",
  API_URL_WF: 'https://pareplicaapi.partanalytics.com/api/v1/workflow',
  redirectUri: "https://pareplicaadmin.partanalytics.com/",
  SSOClientId: "99bccbc6-4e40-4ccd-a3e5-6d0d8d83aeb9",
  SSOTenantId: "2659483d-ae03-4acb-a64b-42478a67b671",
  SSOScopes: {
    "scopes": ["api://84398398-07c7-45fe-870b-5ca98760e386/.default"]
  },
  appRedirectUri: "https://pareplica.partanalytics.com/dashboard/bom",
  bucketURL: 'https://pa-web-file-uploads.s3.amazonaws.com',
  cbomConfigurationCompanyIds: ['5c096351-c8fe-4e00-b5cf-f9971edd2440'],
  expiryTokenTime: 3,
  issuer: "https://altium.okta.com",
  clientId: "0oa1bmqccqtp9km2r1t8"
};

